import { render, staticRenderFns } from "./DarkToggler.vue?vue&type=template&id=10a89ab8&scoped=true&"
import script from "./DarkToggler.vue?vue&type=script&lang=js&"
export * from "./DarkToggler.vue?vue&type=script&lang=js&"
import style0 from "./DarkToggler.vue?vue&type=style&index=0&id=10a89ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a89ab8",
  null
  
)

export default component.exports